// Google Analytics 4 helper — dynamic gtag loader + event sender.
// Measurement ID is read from public site_settings.ga_measurement_id (fallback below).

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    __GA_ID__?: string;
  }
}

const FALLBACK_ID = "G-E2PE6B0ZC8";
let initialized = false;

export function initGA(measurementId?: string | null) {
  if (initialized || typeof window === "undefined") return;
  const id = (measurementId || FALLBACK_ID).trim();
  if (!id || !/^G-[A-Z0-9]+$/i.test(id)) return;
  initialized = true;
  window.__GA_ID__ = id;

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.gtag = function gtag() { window.dataLayer.push(arguments as any); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: true });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
}

export function gaEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  try { window.gtag?.("event", name, params); } catch { /* noop */ }
}

export function gaPageView(path: string) {
  if (typeof window === "undefined" || !window.__GA_ID__) return;
  try {
    window.gtag?.("config", window.__GA_ID__, { page_path: path });
  } catch { /* noop */ }
}
